import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import ModalFormSubmitButton from 'components/modal/form/ModalFormSubmitButton';
import { ModalFooter } from 'react-bootstrap';
import { useFormState } from 'react-hook-form';
import useTriggerAddEditModalInitializeAsDirty from './useTriggerAddEditModalInitializeAsDirty';
import { TriggerAddEditModalFormValues } from './TriggerAddEditModal.schema';

interface TriggerAddEditModalFooterProps {
  closeModal: () => void;
  initializeWith?: TriggerAddEditModalFormValues;
}

const TriggerAddEditModalFooter = ({
  closeModal,
  initializeWith,
}: TriggerAddEditModalFooterProps) => {
  const { isValid } = useFormState();

  useTriggerAddEditModalInitializeAsDirty({ initializeWith });

  return (
    <ModalFooter>
      <ModalFormCancelButton closeOnClick={false} onClick={closeModal} />
      <ModalFormSubmitButton disabled={!isValid} />
    </ModalFooter>
  );
};

export default TriggerAddEditModalFooter;
